import { ExpenditureTypeEnum } from '@app/enums/expenditure-type.enum';

export class Expenditure {
    showInputOnTypes = {
        payment: [
            ExpenditureTypeEnum.alimony,
            ExpenditureTypeEnum.mortgage,
            ExpenditureTypeEnum.buildingSavingsLoan,
            ExpenditureTypeEnum.nonbankLoan,
            ExpenditureTypeEnum.leasing,
            ExpenditureTypeEnum.businessLoan,
            ExpenditureTypeEnum.other,
            ExpenditureTypeEnum.consumerLoan,
        ],
        limit: [ExpenditureTypeEnum.overdraft, ExpenditureTypeEnum.creditCard],
        balance: [
            ExpenditureTypeEnum.mortgage,
            ExpenditureTypeEnum.buildingSavingsLoan,
            ExpenditureTypeEnum.nonbankLoan,
            ExpenditureTypeEnum.leasing,
            ExpenditureTypeEnum.businessLoan,
            ExpenditureTypeEnum.other,
            ExpenditureTypeEnum.consumerLoan,
        ],
    };
}
